"use strict";
import cardConfig from "./cardConfig";
export const settings = {
    DEF_LENGTH: [16],
    options: {message: 'Invalid Card Number', level: "ERROR"}
};

function toDigits(value) {
    return (value || '').replace(/\D+?/g, '').split('').map(function (v) {
        return parseInt(v, 10);
    });
}

function luhnCheck(config, luhn) {
    if (!config.luhn) {
        return true;
    }
    var len = luhn.length,
        mul = 0,
        prodArr = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [0, 2, 4, 6, 8, 1, 3, 5, 7, 9]],
        sum = 0;

    while (len--) {
        sum += prodArr[mul][parseInt(luhn[len], 10)];
        mul ^= 1;
    }

    return sum % 10 === 0 && sum > 0;

}
function lengthCheck(config, digits) {
    return (config.length || settings.DEF_LENGTH).indexOf(digits.length) > -1;
}

function cardValidator(value) {
    if (!value) return true;
    const config = cardConfig.match(value);
    const digits = toDigits(value);
    return config && lengthCheck(config, digits) && luhnCheck(config, digits);
}

export default function validate$card(options) {
    const opts = options ? {
        ...settings.options,
        ...options
    } : settings.options;

    return function validate$card$return(value) {
        if (cardValidator(value)) {
            return null;
        }
        return {
            type: 'ERROR',
            level: opts.level,
            message: opts.message
        }
    };
}



/** WEBPACK FOOTER **
 ** ./src/types/card/cardValidator.js
 **/